import { atom } from 'jotai';

export type ActiveDevice = 'desktop' | 'mobile';
export type ActiveLanguage = 'pt-BR' | 'en-US' | 'es-ES';
export type RightPanelTab = 'preview' | 'properties' | 'layers';

export interface EditorUiState {
  activeDevice: ActiveDevice;
  activeLanguage: ActiveLanguage;
  rightPanelTab: RightPanelTab;
  canvasZoom: number;
}

export const editorUiAtom = atom<EditorUiState>({
  activeDevice: 'desktop',
  activeLanguage: 'pt-BR',
  rightPanelTab: 'preview',
  canvasZoom: 1,
});

editorUiAtom.debugLabel = 'slide-editor/editorUiAtom';
